import { createFileRoute } from '@tanstack/react-router'
import PortalImoveisPage from '@/pages/portais/portal-imoveis-page'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/portais/$portalvalue/',
)({
  component: function PortalImoveisRoute() {
    const { dashboardId, portalvalue } = Route.useParams()
    
    return (
      <RequireModule module={MODULES.PORTAIS} dashboardId={dashboardId}>
        <PortalImoveisPage dashboardId={dashboardId} portalValue={portalvalue} />
      </RequireModule>
    )
  },
})
